<template>
  <template v-if="illustration">
    <template v-for="i in illustrationSVGs" :key="i">
      <component :is="i" v-if="i" v-bind="$attrs" />
    </template>
  </template>
  <template v-else>
    <template v-for="svg in svgs" :key="svg">
      <component :is="svg" v-if="svg" v-bind="$attrs" />
    </template>
  </template>
</template>

<script setup>
// TODO: Move all the svg files that are being used here from the "public" directory to another directory outside "public" to remove the vuepress warnings
import { defineAsyncComponent } from 'vue';

defineOptions({
  inheritAttrs: false,
});

// render an svg by name
const props = defineProps({
  /**
   * Filename of the svg, without extension.
   */
  name: {
    type: String,
    required: true,
  },

  /**
   * Whether the svg is an illustration.
   */
  illustration: {
    type: Boolean,
    default: false,
  },
});

const empty = { render: () => null };

const illustrationSVGs = [
  defineAsyncComponent(() =>
    import(`../../../node_modules/@dialpad/dialtone-icons/dist/svg/illustrations/${props.name}.svg`).catch(() => empty),
  ),
];

const svgs = [
  defineAsyncComponent(() =>
    import(`../public/assets/images/${props.name}.svg?component`).catch(() => empty),
  ),
  defineAsyncComponent(() =>
    import(`../public/assets/images/components/${props.name}.svg?component`).catch(() => empty),
  ),
  defineAsyncComponent(() =>
    import(`../public/assets/images/favicons/${props.name}.svg?component`).catch(() => empty),
  ),
];
</script>
